"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamecheapBuyRequestSchema = void 0;
const mongoose_1 = require("mongoose");
exports.NamecheapBuyRequestSchema = new mongoose_1.Schema({
    domains: [{
            name: String,
            price: Number,
            available: Boolean
        }],
    ip: String,
    fullfilled: Boolean,
    id: String
});
